import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '@/App';
import { Button } from '@/components/ui/button';

export default function LandingPage() {
  const navigate = useNavigate();
  const { user } = React.useContext(AuthContext);

  React.useEffect(() => {
    if (user) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  return (
    <div className="curtain-bg min-h-screen">
      {/* Navbar */}
      <nav className="navbar fixed top-0 left-0 right-0 z-50 px-6 py-4">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <div className="flex items-center">
            <img src="/onk-logo.png" alt="ONK Ajans" style={{ width: '175px', height: 'auto' }} />
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="pt-56 pb-12 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center">
            <h1 
              className="text-5xl sm:text-6xl lg:text-7xl font-bold mb-12 leading-tight"
              style={{ color: '#eda315' }}
              data-testid="hero-title"
            >
              Dijital Oyun Metni Arşivi
            </h1>
          </div>
        </div>
      </section>

      {/* Search Feature Section */}
      <section className="pb-16 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="play-card p-12 rounded-xl text-center" data-testid="feature-search">
            <div className="text-6xl mb-6">🔍</div>
            <h3 className="text-3xl font-bold mb-4 text-black">
              Gelişmiş Arama
            </h3>
            <p className="text-black text-lg max-w-3xl mx-auto mb-8">
              Ajansımız tarafından temsil edilmekte olan yazar ve çevirmenlere ait tiyatro oyunlarının metinlerine oyunun özgün adına, Türkçe adına, yazarına, çevirmenine, türüne ve oyuncu sayısına göre arama yaparak erişebilirsiniz.
            </p>
            <div className="flex gap-4 justify-center flex-wrap">
              <Button
                onClick={() => navigate('/register')}
                className="bg-[#c50605] hover:bg-[#9d0504] text-white text-lg px-8 py-6"
                data-testid="hero-get-started-btn"
              >
                Hesap Oluştur
              </Button>
              <Button
                onClick={() => navigate('/login')}
                variant="outline"
                className="border-2 border-[#c50605] text-[#c50605] hover:bg-[#c50605]/10 text-lg px-8 py-6"
                data-testid="hero-login-btn"
              >
                Giriş Yap
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-amber-900/30 py-8 px-6 mt-20">
        <div className="max-w-6xl mx-auto text-center text-gray-400 text-sm">
          <p>© 2025 ONK Ajans Fikir ve Sanat Eserleri A.Ş.</p>
        </div>
      </footer>
    </div>
  );
}